enum MemberRoleEnum {
  Admin = 'admin',
  Manager = 'manager',
  ReadOnly = 'read_only',
}

export default MemberRoleEnum
